import React, { lazy } from 'react';
import { XCircle, Trophy, FileText, MessageCircle, Wrench, CheckCircle2, Gift, BookOpen } from 'lucide-react';
export function Features() {
  const painPoints = ['La noche antes de una sesión, todavía no sabes qué vas a hacer con tu cliente', 'Preparas cada sesión desde cero, robándole horas a tu semana', 'Usas la rueda de la vida por quinta vez porque es lo único que tienes a mano', 'Sientes que improvisas — y tienes miedo de que el cliente lo note', 'Te quedas en blanco cuando el cliente dice "no sé de qué hablar hoy"', 'Tus clientes avanzan… pero no lo VEN, y abandonan al mes o dos', 'No sabes qué tarea enviarle entre sesiones (o envías siempre la misma)', 'Terminas buscando "ejercicios de coaching" en Google a las 11 de la noche'];
  const tomes = [{
    title: 'TOMO 1 — Primera Sesión y Onboarding',
    desc: 'Guión minuto a minuto de la sesión de descubrimiento, kit de bienvenida, acuerdo de coaching listo para firmar y evaluación inicial. Convierte la sesión gratuita en un proceso pago.',
    img: 'https://cdn.magicpatterns.com/uploads/9fFnbbxA17DHpK2CyyTUbJ/Tomo_1_.png'
  }, {
    title: 'TOMO 2 — Diagnóstico y Objetivos',
    desc: 'Sesión de diagnóstico profundo, mapa de situación actual vs. deseada, ejercicio de valores con tarjetas y plan de proceso completo. De deseos difusos a objetivos medibles.',
    img: 'https://cdn.magicpatterns.com/uploads/aqhoSprtg4t8ReAu1i1A5w/Tomo_2.png'
  }, {
    title: 'TOMO 3 — 50 Sesiones Listas Para Usar',
    desc: 'El corazón del pack. Cada sesión con objetivo, apertura, ejercicio central, preguntas poderosas, cierre y tarea. Organizadas en 6 bloques. Incluye índice cruzado.',
    img: 'https://cdn.magicpatterns.com/uploads/3zNXTvgwfY1PzwypuMz3X9/Tomo_3.png',
    highlight: true
  }, {
    title: 'TOMO 4 — Herramientas de Desbloqueo',
    desc: '15 protocolos para cliente estancado, manejo de la resistencia, protocolo "no sé de qué hablar hoy", qué hacer cuando el cliente se quiebra en sesión, y cuándo derivar a terapia.',
    img: 'https://cdn.magicpatterns.com/uploads/n8VXLuDusooCMMbdi93GZE/Tomo_4.png'
  }, {
    title: 'TOMO 5 — Seguimiento Entre Sesiones',
    desc: 'Cuaderno del cliente de 12 semanas (entregable con tu marca), banco de 40 tareas, plantillas de notas de sesión y mensajes de seguimiento listos para enviar por WhatsApp.',
    img: 'https://cdn.magicpatterns.com/uploads/8dafM6sxpsY9LKYSHGan3W/tomo_5.png'
  }, {
    title: 'TOMO 6 — Cierre y Renovación',
    desc: 'Sesión de cierre completa, evaluación antes vs. después (el cliente VE su avance), guión de renovación del proceso, sistema de testimonios y referidos.',
    img: 'https://cdn.magicpatterns.com/uploads/b34VU7N31ahD3MqgAkhesh/Tomo_6.png'
  }];
  const bonuses = [{
    title: 'Plan Anti-Caos',
    value: '$15',
    desc: 'Prepara tu sesión de mañana en 10 minutos. El protocolo exacto paso a paso.'
  }, {
    title: 'Banco de Roleplays',
    value: '$18',
    desc: '30 casos de clientes reales para practicar antes de que te pasen en vivo.'
  }, {
    title: 'Banco de 200 Preguntas Poderosas',
    value: '$15',
    desc: 'Organizadas por momento de la sesión: apertura, bloqueo, exploración, acción, cierre.'
  }, {
    title: 'Scripts Coach Seguro',
    value: '$18',
    desc: 'Qué decir textualmente en los 15 momentos incómodos: hablar del precio, silencios, etc.'
  }, {
    title: 'Pack Errores Típicos',
    value: '$12',
    desc: 'Los 20 errores del coach que recién empieza y cómo evitarlos.'
  }];
  return <div className="w-full bg-white" data-id="element-6">
      {/* PAIN POINTS */}
      <section className="py-20 px-4 md:px-8 max-w-5xl mx-auto" data-id="element-7">
        <div className="text-center mb-12" data-id="element-8">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-900 mb-4" data-id="element-9">
            Si eres life coach, seguramente estás lidiando con al menos uno de
            estos problemas:
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-10">
          {painPoints.map((point, i) => <div key={i} className="flex items-start gap-3 bg-cream p-5 rounded-xl border border-brand-50" data-id="element-11">
              <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-12" />
              <p className="text-gray-700 font-medium" data-id="element-13">{point}</p>
            </div>)}
        </div>

        <div className="text-center mt-16" data-id="element-14">
          <h3 className="text-2xl md:text-3xl font-bold text-brand-600" data-id="element-15">
            ¿Y si todo esto ya estuviera hecho por ti?
          </h3>
        </div>
      </section>

      {/* PRODUCT PRESENTATION */}
      <section className="py-20 bg-brand-900 text-white px-4 md:px-8" data-id="element-16">
        <div className="max-w-5xl mx-auto text-center space-y-8" data-id="element-17">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-800 text-accent font-bold text-sm tracking-widest uppercase" data-id="element-18">
            <Trophy className="w-4 h-4" data-id="element-19" /> El sistema más completo en español
          </div>

          <h2 className="text-4xl md:text-5xl font-extrabold text-white" data-id="element-20">
            MEGAPACK LIFE COACH™
          </h2>
          <p className="text-xl md:text-2xl text-brand-100 max-w-3xl mx-auto" data-id="element-21">
            6 Tomos + 5 Bonos + Kit Programas — Del primer contacto al cierre
            del proceso
          </p>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto" data-id="element-22">
            Más de 400 páginas de sesiones listas, herramientas, guiones y
            seguimiento profesional — todo hecho por ti.
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 pt-8 border-t border-brand-800" data-id="element-23">
            <div className="flex flex-col items-center p-4 bg-brand-800/50 rounded-xl" data-id="element-24">
              <FileText className="w-8 h-8 text-accent mb-2" data-id="element-25" />
              <span className="font-bold text-xl" data-id="element-26">400+</span>
              <span className="text-sm text-brand-100" data-id="element-27">Páginas</span>
            </div>
            <div className="flex flex-col items-center p-4 bg-brand-800/50 rounded-xl" data-id="element-28">
              <BookOpen className="w-8 h-8 text-accent mb-2" data-id="element-29" />
              <span className="font-bold text-xl" data-id="element-30">50</span>
              <span className="text-sm text-brand-100" data-id="element-31">Sesiones listas</span>
            </div>
            <div className="flex flex-col items-center p-4 bg-brand-800/50 rounded-xl" data-id="element-32">
              <MessageCircle className="w-8 h-8 text-accent mb-2" data-id="element-33" />
              <span className="font-bold text-xl" data-id="element-34">200+</span>
              <span className="text-sm text-brand-100" data-id="element-35">Preguntas</span>
            </div>
            <div className="flex flex-col items-center p-4 bg-brand-800/50 rounded-xl" data-id="element-36">
              <Wrench className="w-8 h-8 text-accent mb-2" data-id="element-37" />
              <span className="font-bold text-xl" data-id="element-38">30</span>
              <span className="text-sm text-brand-100" data-id="element-39">Herramientas</span>
            </div>
          </div>

          <div className="pt-8 text-sm md:text-base text-brand-100 font-medium flex flex-wrap justify-center gap-x-6 gap-y-2" data-id="element-40">
            <span data-id="element-41">Primera sesión</span> •<span data-id="element-42">Diagnóstico</span> •
            <span data-id="element-43">Proceso completo</span> •<span data-id="element-44">Desbloqueo</span> •
            <span data-id="element-45">Seguimiento</span> •<span data-id="element-46">Cierre y renovación</span>
          </div>
        </div>
      </section>

      {/* THE 6 TOMES */}
      <section className="py-20 px-4 md:px-8 max-w-5xl mx-auto" data-id="element-47">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-brand-900 mb-16" data-id="element-48">
          Los 6 Tomos Completos
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-49">
          {tomes.map((tomo, i) => <div key={i} className={`p-6 md:p-8 rounded-2xl border ${tomo.highlight ? 'bg-brand-50 border-brand-200 shadow-md relative' : 'bg-white border-gray-200'}`} data-id="element-50">
              {tomo.highlight && <div className="absolute -top-3 left-8 bg-accent text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider z-10" data-id="element-51">
                  ⭐ El corazón del pack
                </div>}
              <div className="mb-6 rounded-xl overflow-hidden" data-id="element-52">
                <img src={tomo.img} alt={tomo.title} className="w-full h-auto" loading="lazy" data-id="element-53" />
              </div>
              <h3 className="text-xl font-bold text-brand-900 mb-3" data-id="element-54">
                {tomo.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-55">{tomo.desc}</p>
            </div>)}
        </div>

        <div className="mt-12 bg-cream p-6 rounded-xl border border-brand-100 flex flex-wrap justify-center gap-4 md:gap-8 text-sm font-medium text-brand-800" data-id="element-56">
          <span className="flex items-center gap-2" data-id="element-57">
            <CheckCircle2 className="w-5 h-5 text-brand-500" data-id="element-58" /> Sesiones listas
          </span>
          <span className="flex items-center gap-2" data-id="element-59">
            <CheckCircle2 className="w-5 h-5 text-brand-500" data-id="element-60" /> Plantillas
          </span>
          <span className="flex items-center gap-2" data-id="element-61">
            <CheckCircle2 className="w-5 h-5 text-brand-500" data-id="element-62" /> Guiones
          </span>
          <span className="flex items-center gap-2" data-id="element-63">
            <CheckCircle2 className="w-5 h-5 text-brand-500" data-id="element-64" /> Entregables
          </span>
          <span className="flex items-center gap-2" data-id="element-65">
            <CheckCircle2 className="w-5 h-5 text-brand-500" data-id="element-66" /> Estándares ICF
          </span>
        </div>
      </section>

      {/* BONUSES */}
      <section className="py-20 bg-brand-50 px-4 md:px-8" data-id="element-67">
        <div className="max-w-5xl mx-auto" data-id="element-68">
          <div className="text-center mb-16" data-id="element-69">
            <h2 className="text-3xl md:text-4xl font-bold text-brand-900 mb-4" data-id="element-70">
              Los 5 Bonos Estratégicos
            </h2>
            <p className="text-xl text-brand-600 font-medium" data-id="element-71">
              🎁 Incluidos sin costo extra — Valor total: $78 →{' '}
              <span className="font-bold text-brand-900" data-id="element-72">
                GRATIS con tu MegaPack
              </span>
            </p>
          </div>

          <div className="space-y-4" data-id="element-73">
            {bonuses.map((bono, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-sm border border-brand-100 flex flex-col md:flex-row md:items-center gap-4 md:gap-6" data-id="element-74">
                <div className="w-12 h-12 bg-accent/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-75">
                  <Gift className="w-6 h-6 text-accent" data-id="element-76" />
                </div>
                <div className="flex-grow" data-id="element-77">
                  <div className="flex flex-wrap items-baseline gap-3 mb-1" data-id="element-78">
                    <h3 className="text-lg font-bold text-brand-900" data-id="element-79">
                      BONO 0{i + 1} — {bono.title}
                    </h3>
                    <span className="text-sm text-gray-400 line-through" data-id="element-80">
                      {bono.value}
                    </span>
                    <span className="text-sm font-bold text-brand-600" data-id="element-81">
                      GRATIS
                    </span>
                  </div>
                  <p className="text-gray-600" data-id="element-82">{bono.desc}</p>
                </div>
              </div>)}
          </div>
        </div>
      </section>
    </div>;
}